export const RESCHEDULE_PENDING_KEY = 'index12306_reschedule_pending'

export const saveReschedulePending = (payload) => {
  sessionStorage.setItem(RESCHEDULE_PENDING_KEY, JSON.stringify(payload))
}

export const loadReschedulePending = () => {
  const raw = sessionStorage.getItem(RESCHEDULE_PENDING_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export const clearReschedulePending = () => {
  sessionStorage.removeItem(RESCHEDULE_PENDING_KEY)
}
